<template>
    <v-card v-if="generalInfo" :loading="loading" class="elevation-3">
        <div class="card-title pointer" @click="expanded = !expanded">
            {{ $t('ProcessTitle') }}: {{ generalInfo.processTitle }}
            <v-icon v-if="!expanded" class="float-end">mdi-chevron-down</v-icon>
            <v-icon v-if="expanded" class="float-end">mdi-chevron-up</v-icon>
        </div>
        <v-container v-if="expanded" fluid>
            <template>
                <v-row>
                    <label-data :data="generalInfo.processNumber" :label="$t('ProcessNumber')" />
                    <label-data :data="generalInfo.referenceNumber" :label="$t('ReferenceNumber')" />
                    <label-data :translated="true" :data="generalInfo.status" :label="$t('Status')" css-class="red--text text--darken-4" />
                    <label-data :translated="true" :data="generalInfo.stage" :label="$t('Stage')" css-class="red--text text--darken-4" />
                    <label-data :data="generalInfo.createdDate | formatDateGregorian" :label="$t('CreatedDate')" />
                    <label-data :data="generalInfo.processType" :label="$t('ProcessType')" />
                </v-row>
                <v-divider class="mt-3 mb-3" />
                <v-row v-if="generalInfo.isFieldMission">
                    <label-data :data="generalInfo.annualPlanTitle" :label="$t('AnnualPlan')" />
                    <label-data :data="generalInfo.annualPlanPeriodTitle" :label="$t('AnnualPlanPeriodTitle')" />
                    <label-data :data="generalInfo.executionMethod" :label="$t('ExecutionMethod')" />
                    <LabelData :label="$t('TaskType')" :data="$t(generalInfo.taskType)" />
                    <LabelData :label="$t('ExecutionMethod')" :data="$t(generalInfo.executionMethod)" />
                    <LabelData :label="$t('Structure')" :data="$t(generalInfo.structure)" />
                    <LabelData :label="$t('ResponsibleStructure')" :data="$t(generalInfo.responsibleStructure)" />
                    <LabelData :label="$t('Description')" :data="generalInfo.taskDescription" />
                    <LabelData :label="$t('TaskSelectionStandards')" :data="generalInfo.selectionStandards" />
                    <LabelData :label="$t('ScopeOfReview')" :data="generalInfo.scopeOfReview" />
                    <LabelData :label="$t('Reviewers')" :data="generalInfo.reviewers" />
                    <LabelData :label="$t('MissionCoordinator')" :data="generalInfo.missionCoordinator" />
                </v-row>
                <v-row v-if="generalInfo.isGenericReplies">
                    <LabelData :label="$t('ExternaleLetterNumber')" :data="generalInfo.externaleLetterNumber" />
                    <LabelData :label="$t('InternalLetterNumber')" :data="generalInfo.internalLetterNumber" />
                    <LabelData :label="$t('LetterDate')" :data="generalInfo.letterDate | formatDateGregorian" />
                    <LabelData :label="$t('EstimatedReplyDate')" :data="generalInfo.estimatedReplyDate | formatDateGregorian" />
                    <LabelData :label="$t('ResponsibleStructure')" :data="generalInfo.responsibleStructure" />
                    <LabelData :label="$t('SendingInternalStructure')" :data="generalInfo.sendingInternalStructure" />
                    <LabelData :label="$t('SendingExternalStructure')" :data="generalInfo.sendingExternalStructure" />
                    <LabelData :label="$t('Reviewer')" :data="generalInfo.reviewer" />
                    <LabelData :label="$t('Description')" :data="generalInfo.description" />
                </v-row>

                <v-row v-if="generalInfo.isRegulatoryAuthority">
                    <LabelData :label="$t('EntityOutgoingNumber')" :data="generalInfo.entityOutgoingNumber" />
                    <LabelData :label="$t('IncomingLetterNumber')" :data="generalInfo.incomingLetterNumber" />
                    <LabelData :label="$t('EntityOutgoingDate')" :data="generalInfo.entityOutgoingDate | formatDateGregorian" />
                    <LabelData :label="$t('IncomingLetterDate')" :data="generalInfo.incomingLetterDate | formatDateGregorian" />
                    <LabelData :label="$t('EstimatedReplyDate')" :data="generalInfo.estimatedReply" />
                    <LabelData :label="$t('ExecutionWay')" :data="generalInfo.executionWay" />
                    <LabelData :label="$t('RelatedProcess')" :data="generalInfo.relatedProcess" />
                    <LabelData :label="$t('Description')" :data="generalInfo.description" />
                </v-row>
                <v-row v-if="generalInfo.planTaskLinkages">
                    <v-col v-for="link in generalInfo.planTaskLinkages" :key="link.selectedText">
                        <b>{{link.tableName}}</b>
                        <div>
                            {{link.selectedText}}
                            <span v-if="link.isDocument">
                                <v-icon color="secondary" class="ms-3" @click="loadAttachment(link.id)">mdi-eye</v-icon>
                            </span>
                        </div>
                    </v-col>
                </v-row>
            </template>
        </v-container>
        <CommonDialog v-model="attachmentDialog" :title="$t('Attachment')" css-content-class="pa-0" @input="attachmentDialog= false">
            <v-container fluid class="stretch">
                <FileViewer :query="documentQuery" name="taskAttachment" />
            </v-container>
        </CommonDialog>
    </v-card>
</template>
<script>
    import LabelData from '@/components/controls/LabelData.vue'
    import FileViewer from '@/components/controls/FileViewer.vue'
    import CommonDialog from '@/components/controls/CommonDialog.vue'
    import AttachmentsService from '@/services/AttachmentsService.js'

    export default {
        components: {
            LabelData, CommonDialog, FileViewer
        },

        props: {
            generalInfo: {
                type: Object,
                default: function () { },
            },
        },

        data() {
            return {
                attachmentDialog: false,
                loading: false,
                expanded: true,
                documentQuery: null,
            }
        },

         methods: {
            loadAttachment(attachmentId) {
                AttachmentsService.getAttachment(attachmentId).then(response => {
                    this.documentQuery = response.data
                    this.attachmentDialog = true
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                })
            },

        }

    }
</script>
